const logs = require("@/classes/logs/logs.js").Logs;
var manage = {};
manage.db = null;
manage.init = async function(parent) {
  this.db = parent.fb;
  this.parent = parent;
  this.email = await parent.adminUser.getAccount();
  //logs.print("type:", parent.type)
  //this.ref = this.db.playersCollection
  //this.usersRef = this.db.usersCollection.doc(this.email).collection("users")
  manage.getUser();
};
manage.updateUser = function(res) {
  manage.parent.pageLoading = false;
  if (res.status) {
    logs.print("res.data", res.data);
    res.data = manage.parent.adminUser.fixUser(res.data);
    manage.parent.user = res.data;
  } else {
    console.error(res.error_msg);
  }
  manage.getAllPlayers();
  manage.getAllSubUsers();
};
manage.changeName = function(email, name, accountName) {
  manage.parent.pageLoading = true;
  manage.parent.adminUser.sendToServerData(
    "put",
    "/users/" + email,
    {
      name: name,
      accountName: accountName,
    },
    function(res) {
      manage.updateUser(res);
    },
    function() {}
  );
};
manage.addSubUser = function(email, subUser) {
  //subUser is email
  manage.parent.pageLoading = true;
  manage.parent.adminUser.sendToServerData(
    "put",
    "/users/" + email + "/sub_user",
    {
      sub_user: subUser,
    },
    function(res) {
      manage.updateSubUsers(res);
    },
    function() {
      manage.parent.pageLoading = false;
    }
  );
};
manage.addTrial = function(email) {
  manage.parent.pageLoading = true;
  manage.parent.adminUser.sendToServerData(
    "put",
    "/users/" + email + "/trial",
    {},
    function(res) {
      logs.print("manage.addTrial", res);
      if (res.status) {
        manage.parent.adminUser.clearServerCache(manage.parent.updateParent);

        manage.parent.$toastr("success", manage.parent.lang.add_trial_success);
      } else {
        manage.parent.$toastr("error", res.error_msg);
        console.error("manage.addTrial", res.error_msg);
      }

      manage.parent.pageLoading = false;
    },
    function() {
      manage.parent.pageLoading = false;
    }
  );
};
manage.updateSubUsers = function(res) {
  manage.parent.pageLoading = false;
  if (res.status) {
    res.data = manage.parent.adminUser.fixUser(res.data);
    manage.parent.subUsers = res.data;
  } else {
    console.error(res.error_msg);
  }
};
manage.getSubUsers = function(email) {
  manage.parent.pageLoading = true;
  manage.parent.adminUser.sendToServerData(
    "get",
    "/users/" + email + "/sub_users",
    function(res) {
      if (res.status) {
        logs.print("res.data subusers", res.data);
        manage.parent.subUsers = res.data;
      } else {
        console.error(res.error_msg);
      }
    },
    function() {}
  );
};
manage.getAllSubUsers = function() {
  manage.parent.subUsers = [];
  this.parent.adminUser.getUserSubUsers(
    this.parent.email,
    manage.updateSubUsers
  );
};
manage.deleteSubUser = function(email, subUserEmail) {
  manage.parent.adminUser.sendToServer(
    "delete",
    "/users/" + email + "/sub_users/" + subUserEmail,
    function(res) {
      logs.print("subuser.del", res);
      if (res.status) {
        manage.parent.$toastr("success", manage.parent.lang.delete_success);
      } else {
        manage.parent.$toastr("error", manage.parent.lang[res.error_msg]);
      }
      manage.updateSubUsers(res);
    },
    function() {}
  );
};
manage.updateSubUsers = function(res) {
  if (res.status) {
    manage.parent.subUsers = res.data;
  } else {
    console.error(res.error_msg);
    //Vue.prototype.$toastr("error", res.error_msg);
  }
};
manage.changeStatus = function(email, status) {
  manage.parent.pageLoading = true;
  manage.parent.adminUser.sendToServer(
    "put",
    "/users/" + status + "/" + email,
    function(res) {
      manage.updateUser(res);
    },
    function() {}
  );
};
manage.getUser = function() {
  manage.parent.user = {};
  this.parent.adminUser.getUserDetails(this.parent.email, this.updateUser);
};

manage.getAllPlayers = function() {
  manage.parent.players = [];
  this.parent.adminUser.getUserPlayers(this.parent.email, manage.updatePlayers);
};
manage.updatePlayers = function(res) {
  if (res.status) {
    manage.parent.players = res.data;
  } else {
    console.error(res.error_msg);
    //Vue.prototype.$toastr("error", res.error_msg);
  }
};
manage.destroy = function() {
  manage.parent = null;
  if (manage.unsub) {
    manage.unsub();
  }
};
export { manage };
